import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const SkinCareRoutine = lazyWithPreload(
  () => import('./SkinCareRoutine'),
)
export const LikeChatSkinCareRoutine = lazyWithPreload(
  () => import('./LikeChatSkinCareRoutine'),
)
